import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { cloneElement } from 'react';
import { propBool, propChildren, propStr, } from '../../helpers/custom-prop-types';
import Help from '../Help';
import SlideSearchCircleLink from '../Ui/SlideSearch/SlideSearchCircleLink';
import ScrollToTopButton from './ScrollToTopButton';
const FooterStickyComponent = (props) => {
    const { children, className, isLoading, renderStickyComponent, showHelp, showProffitSearchLink, } = props;
    return (_jsx("div", Object.assign({ className: clsx('footer-sticky-wrapper', showProffitSearchLink && 'is-show-proffit-search-link', className) }, { children: renderStickyComponent ? (cloneElement(renderStickyComponent, {
            isLoading,
            showHelp,
            showProffitSearchLink,
        })) : (_jsxs(_Fragment, { children: [showProffitSearchLink && (_jsxs(_Fragment, { children: [_jsx("div", { className: 'footer-sticky-proffit-search-spacer' }), _jsx("div", Object.assign({ className: 'footer-sticky-proffit-search-link' }, { children: _jsx(SlideSearchCircleLink, {}) }))] })), _jsxs("div", Object.assign({ className: 'footer-buttons-wrapper' }, { children: [!isLoading && _jsx(ScrollToTopButton, {}), showHelp && _jsx(Help, {})] })), children] })) })));
};
FooterStickyComponent.propTypes = {
    children: propChildren(),
    className: propStr().isRequired,
    isLoading: propBool().isRequired,
    renderStickyComponent: propChildren(),
    showHelp: propBool().isRequired,
    showProffitSearchLink: propBool().isRequired,
};
FooterStickyComponent.defaultProps = {
    children: null,
    renderStickyComponent: undefined,
};
export default FooterStickyComponent;
